import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { facilityService, LiveSeatInfo } from 'services/facilityService';
import * as S from './PlaceStates.styles';

const PlaceStates: React.FC = () => {
  const navigate = useNavigate();
  const [seatInfo, setSeatInfo] = useState<LiveSeatInfo[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchSeatInfo = async () => {
      try {
        const response = await facilityService.getLiveSeatInfo(0, 20);
        setSeatInfo(response.content);
      } catch (error) {
        console.error('Failed to fetch live seat info:', error);
        setSeatInfo([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSeatInfo();
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  const getRatio = (occupiedSeats: number, totalSeats: number) => {
    return occupiedSeats / totalSeats;
  };

  return (
    <S.Container>
      <S.Header>
        <S.BackButton onClick={handleGoBack}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </S.BackButton>
        <S.Title>열람실 현황</S.Title>
      </S.Header>

      <S.Content>
        {isLoading ? (
          <S.LoadingContainer>로딩 중...</S.LoadingContainer>
        ) : seatInfo.length === 0 ? (
          <S.EmptyContainer>열람실 정보가 없습니다.</S.EmptyContainer>
        ) : (
          seatInfo.map((info) => (
            <S.FacilityCard key={info.facilityName}>
              <S.FacilityHeader>
                <S.FacilityInfo>
                  <S.FacilityName>{info.facilityName}</S.FacilityName>
                </S.FacilityInfo>
              </S.FacilityHeader>
              <S.SeatCount>
                {info.occupiedSeats}/{info.totalSeats}
              </S.SeatCount>
              <S.ProgressBarContainer>
                <S.ProgressBar ratio={getRatio(info.occupiedSeats, info.totalSeats)} />
              </S.ProgressBarContainer>
            </S.FacilityCard>
          ))
        )}
      </S.Content>

      <S.InfoBox>
        <S.InfoIcon>i</S.InfoIcon>
        <S.InfoText>
          현재 페이지는 해당 시설의 간략정보만 제공합니다.
          <br />
          좌석 배정은 도서관 앱을 이용하여 주십시오.
        </S.InfoText>
      </S.InfoBox>
    </S.Container>
  );
};

export default PlaceStates;
